import { useInView } from '../../hooks/useInView';

export default function HowItWorks({ steps, appUrl, primaryCta }) {
  const [ref, inView] = useInView(0.1);

  return (
    <section id="how-it-works" className="py-20 sm:py-28 bg-slate-50">
      <div className="max-w-5xl mx-auto px-5 sm:px-8">
        <div className="text-center mb-14">
          <h2 className="text-3xl sm:text-4xl font-extrabold text-slate-900 tracking-tight mb-4">
            How It Works
          </h2>
          <p className="text-slate-500 max-w-md mx-auto leading-relaxed">
            Three simple steps — no learning curve required.
          </p>
        </div>

        <div
          ref={ref}
          className="grid grid-cols-1 md:grid-cols-3 gap-8 relative"
        >
          {/* Connector line (desktop) */}
          <div className="hidden md:block absolute top-10 left-[calc(16.67%+1.5rem)] right-[calc(16.67%+1.5rem)] h-px bg-gradient-to-r from-brand-blue/30 via-brand-indigo/30 to-brand-blue/30" />

          {steps.map((step, i) => (
            <div
              key={step.step}
              className="flex flex-col items-center text-center"
              style={{
                opacity: inView ? 1 : 0,
                transform: inView ? 'translateY(0)' : 'translateY(24px)',
                transition: `opacity 0.55s ease ${i * 0.12}s, transform 0.55s ease ${i * 0.12}s`,
              }}
            >
              {/* Step number */}
              <div className="relative z-10 w-20 h-20 rounded-full bg-brand-gradient flex items-center justify-center shadow-lg shadow-brand-blue/30 mb-6">
                <span className="text-white font-extrabold text-2xl">{step.step}</span>
              </div>
              <h3 className="font-bold text-slate-900 text-lg mb-2">{step.title}</h3>
              <p className="text-slate-500 text-sm leading-relaxed">{step.description}</p>
            </div>
          ))}
        </div>

        <div className="mt-14 text-center">
          <a
            href={appUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 px-8 py-4 rounded-full bg-brand-gradient text-white font-bold text-base shadow-lg shadow-brand-blue/30 hover:shadow-brand-blue/50 hover:scale-105 transition-all duration-200"
          >
            {primaryCta}
          </a>
        </div>
      </div>
    </section>
  );
}
